/* eslint-disable react/prop-types */
import React from 'react';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Icon, Box, NakedButton } from 'roo-ui/components';
import { BoxButton } from './primitives';
import SkipToContentButton from 'components/SkipToContentButton';

const GalleryIcon = styled(Icon)`
  filter: drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.8));
`;

const GalleryButton = styled(BoxButton)`
  opacity: 0.8;

  &:focus {
    background-color: rgba(255, 255, 255, 0.75);
    outline: ${themeGet('focus.outline')};
    opacity: 1;
  }

  &:hover {
    opacity: 1;
  }
`;

GalleryButton.defaultProps = {
  ...BoxButton.defaultProps,
  position: 'absolute',
  zIndex: 'imageGallery',
  border: '3px solid transparent',
};

export const ImageButton = styled(NakedButton)`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  height: 100%;
`;

const TotalImagesTextWrapper = styled(Box)`
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: ${themeGet('colors.white')};
  border-radius: ${themeGet('radii.default')};
  margin: ${themeGet('space.4')};
  padding: ${themeGet('space.2')};
  pointer-events: none;
`;

export const TotalImagesText = ({ images }) => <TotalImagesTextWrapper>Show {images.length} images</TotalImagesTextWrapper>;

const HiddenLinkButton = styled(SkipToContentButton)`
  position: absolute;
  z-index: ${themeGet('zIndices.imageGallery')};
  border-radius: ${themeGet('radii.default')};
  letter-spacing: initial;
  font-weight: initial;
  text-transform: none;
`;

HiddenLinkButton.defaultProps = {
  ...BoxButton.defaultProps,
};

const Button = ({ children, icon, title, size, ...rest }) => {
  return (
    <GalleryButton {...rest}>
      {icon && <GalleryIcon name={icon} title={title} color="white" size={size} />}
      {children}
    </GalleryButton>
  );
};

export const LeftNav = ({ onClick }) => (
  <Button icon="chevronLeft" title="previous image" onClick={onClick} size={[40, 60]} top="50%" left="0" marginTop={['-30px', '-20px']} />
);

export const RightNav = ({ onClick }) => (
  <Button icon="chevronRight" title="next image" onClick={onClick} size={[40, 60]} top="50%" right="0" marginTop={['-30px', '-20px']} />
);

export const CloseButton = ({ onClick }) => (
  <Button icon="close" title="close fullscreen gallery" onClick={onClick} size={[30, 40]} right={0} top={0} m={2} p={2} />
);

export const SkipLink = ({ href }) => (
  <HiddenLinkButton as="a" href={href} color="black" bg="white" left={0} top={0} m={4} p={2}>
    Skip image gallery
  </HiddenLinkButton>
);
